import { EmptyStateBox } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

type Props = {
  message: string;
  onRetry: () => void;
};

const LoadErrorMessage = ({ message, onRetry }: Props) => (
  <Typography sx={{ color: 'content.disabled', fontSize: 'inherit' }}>
    {message}{' '}
    <EmptyStateBox.ClickableText
      onClick={() => onRetry()}
      sx={{ fontSize: 'inherit' }}
    >
      Try again
    </EmptyStateBox.ClickableText>
  </Typography>
);

export default LoadErrorMessage;
